import React from 'react';
import PropTypes from 'prop-types';
import QuoteProductDetail from '../../quotes/entities/quoteProductDetail';
import { QuoteProductConfiguration } from '../../quotes/quoteProductConfiguration';

class ProductBucketQuoteProductSelectionItemComponent extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
    onUpdate: PropTypes.func.isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration)
      .isRequired,
    onFinishBucketConfiguration: PropTypes.func.isRequired,
  };

  onUpdateEntity(property, value) {
    var entity = this.props.entity;
    entity[property] = value;
    this.props.onUpdate(new QuoteProductDetail({ ...entity }));
    this.props.onFinishBucketConfiguration(true);
  }

  getProductGroup() {
    const { quoteProductConfiguration, product } = this.props;
    var productGroup = quoteProductConfiguration.productGroups.find(
      (x) => x.id === product.productGroupId
    );
    return productGroup;
  }

  render() {
    const { entity, product } = this.props;
    const productGroup = this.getProductGroup();
    return (
      <tr>
        <td>
          <img
            src={productGroup.imageUrl}
            className="img-fluid"
            alt={productGroup.name}
            style={{ maxWidth: 100 }}
          />
        </td>
        <td className="product-details">
          <div className="row">
            <div className="col">
              <div className="group-name">{productGroup.name}</div>
              <div className="dimensions">
                {product.dimensions.map((dimension, idx) => (
                  <div className="row" key={idx}>
                    <div className="col-auto text-nowrap">{`${dimension.name}:`}</div>
                    <div className="col-auto text-break-line">
                      {dimension.value}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </td>
        <td className="clearfix">
          <button
            type="button"
            className={`select-button btn ${product.id === entity.bucketQuoteProductId
                ? 'btn-success'
                : 'btn-primary'
              } btn-sm`}
            onClick={() =>
              this.onUpdateEntity('bucketQuoteProductId', product.id)
            }
          >
            {product.id === entity.bucketQuoteProductId ? 'Selected' : 'Select'}
          </button>
        </td>
      </tr>
    );
  }
}

export default ProductBucketQuoteProductSelectionItemComponent;
